module.exports = __webpack_public_path__ + "static/media/1 07 profesjonelt.cfc3b4b6.mp3";